/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppDeleteVideoEditorEditsEditMutationResponse, WebAppDeleteVideoEditorEditsEditPathParams } from "../models/WebAppDeleteVideoEditorEditsEdit";

export function getWebAppDeleteVideoEditorEditsEditUrl(id: WebAppDeleteVideoEditorEditsEditPathParams["id"]) {
  const res = { method: 'DELETE', url: `/web-app/video-editor/edits/${id}` as const }
  return res
}

/**
 * @summary Delete an edit
 * {@link /web-app/video-editor/edits/:id}
 */
export async function webAppDeleteVideoEditorEditsEdit(id: WebAppDeleteVideoEditorEditsEditPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppDeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getWebAppDeleteVideoEditorEditsEditUrl(id).url.toString(), ... requestConfig })
  return res.data
}